namespace Portico.Models.Enterprise {

    export interface ILayoutSectionQuestion {
        id: number;
        questionId: number;
        sequence: number;
    }

    export class LayoutSectionQuestion implements ILayoutSectionQuestion {
        id: number;
        questionId: number;
        sequence: number;

        constructor(obj?: ILayoutSectionQuestion | any) {
            this.id = null;
            this.questionId = null;
            this.sequence = null;

            if (obj) {
                this.id = obj.id;
                this.questionId = obj.questionId;
                this.sequence = obj.sequence;
            }
        }
    }
}